// extracted by mini-css-extract-plugin
export default {"left":"+yw2f","center":"FIrWn","right":"TdriM","onImage":"HMQ6Y","offImage":"p9kfQ"};